import { render } from "./iconModal.vue?vue&type=template&id=556a6a2e&scoped=true"
import script from "./iconModal.vue?vue&type=script&lang=js"
export * from "./iconModal.vue?vue&type=script&lang=js"

import "./iconModal.vue?vue&type=style&index=0&id=556a6a2e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-556a6a2e"

export default script